module.exports = __webpack_public_path__ + "img/f15e07e.png";